'use strict';

module.exports = {
    'lang': 'zh-cn',
    'copy': '复制',
    'cut': '剪切',
    'copyReady': '已复制',
    'cutReady': '已剪切',
    'copyToClipboard': '复制到剪切板',
    'close': '关闭',

    'en-us': {
        'copy': 'Copy',
        'cut': 'Cut',
        'copyReady': 'Copied',
        'cutReady': 'Cut',
        'copyToClipboard': 'Copy to Clipboard',
        'close': 'Close'
    },
    'zh-tw': {
        'copy': '複製',
        'cut': '剪切',
        'copyReady': '已複製',
        'cutReady': '已剪切',
        'copyToClipboard': '複製到剪切板',
        'close': '關閉'
    }
};